<template>
  <div class="social-icons">
    <div class="error-text">{{ error }}</div>
    <ul style="padding:0px;">
      <div class="list-social">
        <li @click="loginBySocial('GoogleAuthProvider')" class="mr-1" style="background: #FFFAFA;">
          <a>
            <i class="fa fa-google"></i>
          </a>
        </li>
        <li
          @click="loginBySocial('FacebookAuthProvider')"
          class="ml-1"
          style="background: #FFFAFA;"
        >
          <v-btn color="indigo" class="white--text" fab icon small>
            <v-icon>{{ 'mdi-facebook' }}</v-icon>
          </v-btn>
        </li>
      </div>
    </ul>
  </div>
</template>
<script>
import * as firebase from "firebase/app";
import { auth, analytics } from "@/config/firebaseConfig";
import { addUserMGMDataBase  } from "@/functions/MGM/dataBaseMGM";
export default {
  data() {
    return {
      error: "",
      userFather: this.$route.query.mgm || null,
      newUser: "",
    };
  },
  methods: {
    async loginBySocial(social) {
      try {
        const provider = await new firebase.auth[social]();
        await auth.signInWithPopup(provider);
        await auth.onAuthStateChanged((firebaseUSer) => {
          if (firebaseUSer) {
            this.newUSer = firebaseUSer.uid;
          }
        });
        analytics.logEvent(`Sig_${social}`);
        this.$router.replace({ name: "loggedMain" });
        if (this.userFather != null) {
          this.mgmSendDataBase(this.newUSer, this.userFather);
        }
      } catch (error) {
        this.error = error.message;
      }
    },
    async mgmSendDataBase(idSon, idFather) {
      await addUserMGMDataBase(idSon, idFather, false);
    },
  },
};
</script>

<style>
.list-social {
  height: 50px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.fa-google-plus {
  background: conic-gradient(
      from -45deg,
      #ea4335 110deg,
      #4285f4 90deg 180deg,
      #34a853 180deg 270deg,
      #fbbc05 270deg
    )
    73% 55%/150% 150% no-repeat;
  -webkit-background-clip: text;
  background-clip: text;
  color: transparent;
  -webkit-text-fill-color: transparent;
}
.fa-facebook-plus {
  color: blue;
  background-color: #fff;
}
</style>

